import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=c37c279a&scoped=true"
import script from "./Version.vue?vue&type=script&lang=ts"
export * from "./Version.vue?vue&type=script&lang=ts"
import style0 from "./Version.vue?vue&type=style&index=0&id=c37c279a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37c279a",
  null
  
)

export default component.exports